import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../dropdown/dropdown';
import { useGetMyBetsStatsQuery } from 'store/gamesApi';
import Skeleton from 'components/skeleton/Skeleton';
import styles from './statistics.module.scss';

const Statistics: React.FC = () => {
  const { t } = useTranslation();
  const [period, setPeriod] = useState('allTime');

  const periodOptions = [
    { value: 'allTime', label: t('statistics.periods.allTime') },
    { value: 'today', label: t('statistics.periods.today') },
    { value: 'last7Days', label: t('statistics.periods.last7Days') },
    { value: 'lastMonth', label: t('statistics.periods.lastMonth') },
  ];

  const {
    data: response,
    isLoading,
    isFetching,
  } = useGetMyBetsStatsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const stats = response?.data?.[period] || { bets: 0, wins: 0, wager: 0 };
  const loading = isLoading || isFetching;

  return (
    <div className={styles.statisticsContainer}>
      <Dropdown options={periodOptions} value={period} onChange={setPeriod} />

      <div className={styles.statsGrid}>
        {loading ? (
          <Skeleton style={{ height: '84px', borderRadius: '12px' }} className={styles.fullWidth} />
        ) : (
          <div className={`${styles.statCard} ${styles.fullWidth}`}>
            <div className={styles.statHeader}>
              <span className={styles.statLabel}>{t('statistics.totalWager')}</span>
              <div className={styles.statIcon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
                  <path d="M12 18V6"></path>
                </svg>
              </div>
            </div>
            <div className={styles.statValue}>${stats?.wager || 0}</div>
          </div>
        )}

        {loading ? (
          <Skeleton style={{ height: '84px', borderRadius: '12px' }} />
        ) : (
          <div className={styles.statCard}>
            <div className={styles.statHeader}>
              <span className={styles.statLabel}>{t('statistics.bets')}</span>
              <div className={styles.statIcon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <circle cx="15.5" cy="8.5" r="1.5"></circle>
                  <circle cx="15.5" cy="15.5" r="1.5"></circle>
                  <circle cx="8.5" cy="15.5" r="1.5"></circle>
                  <circle cx="12" cy="12" r="1.5"></circle>
                </svg>
              </div>
            </div>
            <div className={styles.statValue}>{stats.bets}</div>
          </div>
        )}

        {loading ? (
          <Skeleton style={{ height: '84px', borderRadius: '12px' }} />
        ) : (
          <div className={styles.statCard}>
            <div className={styles.statHeader}>
              <span className={styles.statLabel}>{t('statistics.wins')}</span>
              <div className={styles.statIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.333"
                      d="M4.003 6.004h-1a1.667 1.667 0 1 1 0-3.334h1m0 3.334V1.337h8v4.667m-8 0a4 4 0 0 0 8 0m0 0h1a1.667 1.667 0 1 0 0-3.334h-1m-9.334 12h10.667M6.669 9.774v1.56c0 .367-.313.654-.646.807-.787.36-1.354 1.353-1.354 2.527m4.667-4.894v1.56c0 .367.313.654.647.807.786.36 1.353 1.353 1.353 2.527"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
            <div className={styles.statValue}>{stats.wins}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Statistics;
